export type ParkEventDurationMinutes = 0 | 1 | 5 | 10 | 30 | 60;

export interface ParkEventDurationOption {
  readonly minutes: ParkEventDurationMinutes;
  readonly label: string;
}

export interface ParkEventConfirm {
  readonly durationMinutes: ParkEventDurationMinutes;
}

export const PARK_EVENT_DURATION_OPTIONS: readonly ParkEventDurationOption[] = [
  { minutes: 0, label: 'Immediate' },
  { minutes: 1, label: '1 minute' },
  { minutes: 5, label: '5 minutes' },
  { minutes: 10, label: '10 minutes' },
  { minutes: 30, label: '30 minutes' },
  { minutes: 60, label: '60 minutes' },
] as const;
